import { render } from "./CCheckBoxOld.vue?vue&type=template&id=b3ed14de"
import script from "./CCheckBoxOld.vue?vue&type=script&lang=js"
export * from "./CCheckBoxOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__